export const T = {
    bg: "#0F1117",
    card: "#1A1D27",
    cardB: "#252836",
    accent: "#4ADE80",
    accentSoft: "rgba(74,222,128,0.12)",
    warn: "#FBBF24",
    danger: "#F87171",
    text: "#F1F5F9",
    muted: "#64748B",
    sub: "#94A3B8",
    purple: "#A78BFA",
    blue: "#60A5FA",
  }
  
  export const fonts = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700&family=DM+Mono:wght@400;500&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { background: #0F1117; color: #F1F5F9; font-family: 'DM Sans', sans-serif; }
    input, textarea, button, select { color: #F1F5F9; }
    input, textarea, select { font-size: 16px !important; }
    button:focus-visible, input:focus-visible, textarea:focus-visible, [tabindex]:focus-visible {
      outline: 2px solid #4ADE80; outline-offset: 2px;
    }
  `